/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rounds_Seating_IssuesInputs */



/**
* | output |
* | --- |
* | "{count} issues" |
*
* @param {Rounds_Seating_IssuesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_issues = /** @type {((inputs: Rounds_Seating_IssuesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_IssuesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} problèmes`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} problemas`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} problemas`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} problemi`)
	return /** @type {LocalizedString} */ (`${i?.count} issues`)
});